/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import List from "../components/Lists/List";
import StoredApi from "../utils/StoredAPI";
import { makeStyles } from "@material-ui/core/styles";
import useContainer from "../hooks/useContainer";

import { DragDropContext, Droppable } from "react-beautiful-dnd";
import useCheckBook from "../hooks/useCheckBook";
import useLift from "../hooks/useLift";
import sleep from "../utils/Sleep";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    overflowX: "scroll", // Scroll horizontal
    // width: "auto",
    flex: 1,
  },
  listbg: {
    width: "300px",
    backgroundColor: "#EBECF0",
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const Home = () => {
  const classes = useStyles();
  const [lists, setLists] = useState([]);
  const [listIDs, setListIDs] = useState([]);
  const {
    containers,
    getContainerPosition,
    setContainers,
    updateContainerPosition,
    getOutputContainerPosition,
    updateOutputContainerPositions,
  } = useContainer();
  const isFirtsRender = useRef(true);
  const urlParams = new URLSearchParams(window.location.search);
  const tipo = urlParams.get("tipo");
  const log_usu_id = urlParams.get("log_usu_id");
  const { getCheckBooks, checkBooks } = useCheckBook();
  const { getForkliftDrivers, forkliftDrivers } = useLift();
  const [scrollDirection, setScrollDirection] = useState(null);
  const [scrollInterval, setScrollInterval] = useState(null);
  const containerRef = useRef(null); // Referencia al contenedor con scroll
  const lastPointerPos = useRef({ x: 0, y: 0 }); // Posición real del puntero/dedo
  const verticalScroll = useRef({ interval: null, direction: null, element: null }); // Auto-scroll vertical de columnas
  const dragScrollRaf = useRef(null);
  const isDraggingRef = useRef(false);

  //const user = JSON.parse(localStorage.getItem('DBUSER'));

  // useEffect(() => {
  //   if (!isFirtsRender.current && containers.length > 0) {
  //     updateContainers();
  //   }
  //   isFirtsRender.current = false;
  // }, [containers]);

  useEffect(async () => {
    setLists([
      {
        ancho: 300,
        created_at: {
          seconds: 1677394861,
          nanoseconds: 21000000,
        },
        activo: true,
        title: "Por asignar",
        _id: "0",
        cards: [
          {
            titulo: "LATIN AMERICA",
            codigo: "568-2022",
            id: "ETmsvd2gPWNpZWhOSLRu1",
            position: 0,
            columna: "M1",
            porcentaje: "0",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
          {
            titulo: "SOLUTRANS LOGISTICA",
            codigo: "569-2022",
            id: "ETmsvd2gPWNpZWhOSLRu2",
            position: 0,
            columna: "M1",
            porcentaje: "0",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
        ],
      },
      {
        title: "Muelle 1",
        ancho: 300,
        created_at: {
          seconds: 1677361632,
          nanoseconds: 840000000,
        },
        activo: true,
        _id: "tNeR28sxcYlGKvDAF2uE12",
        cards: [
          {
            titulo: "SARI EXPRESS",
            codigo: "680-2022",
            id: "ETmsvd2gPWNpZWhOSLRu3",
            position: 0,
            columna: "M2",
            porcentaje: "20",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
          {
            titulo: "LATIN AMERICAN",
            codigo: "683-2022",
            id: "ETmsvd2gPWNpZWhOSLRu4",
            position: 1,
            columna: "M1",
            porcentaje: "10",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
          {
            titulo: "LOGISTICA GLOBAL",
            codigo: "685-2022",
            id: "ETmsvd2gPWNpZWhOSLRu5",
            position: 2,
            columna: "M1",
            porcentaje: "0",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
          {
            titulo: "EXPRESS DE EL SALVADOR",
            codigo: "686-2022",
            id: "ETmsvd2gPWNpZWhOSLRu6",
            position: 3,
            columna: "M1",
            porcentaje: "0",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
        ],
      },
      {
        ancho: 300,
        activo: true,
        title: "Muelle 2",
        created_at: {
          seconds: 1677218400,
          nanoseconds: 974000000,
        },
        _id: "krJ5k2nnYwSAWaiJzwFz11",
        cards: [
          {
            titulo: "CONSOLIDADORES",
            codigo: "683-2022",
            id: "ETmsvd2gPWNpZWhOSLRu7",
            position: 0,
            columna: "M2",
            porcentaje: "1",
            fechaModificadoView: "26/07/2023 20:12:43",
          },
        ],
      },
      {
        ancho: 300,
        activo: true,
        title: "Muelle 3",
        created_at: {
          seconds: 1677218400,
          nanoseconds: 974000000,
        },
        _id: "krJ5k2nnYwSAWaiJzwFz10",
        cards: [],
      },
    ]);
    /*const result = await getLista();
        if(result.ok){
            console.log("===",result.listado)
            setLists(result.listado)
        }else{
            message.error('¡Hubo un problema!');
        }*/

    /*axios.get(`/user/${user.email}`)
        .then(res => {
            setLists(res.data.lists)
        })*/
  }, []);

  useEffect(() => {
    getContainerPosition();
  }, []);

  useEffect(() => {
    if (tipo === "salida") {
      getForkliftDrivers();
    } else {
      getCheckBooks();
    }
  }, []);

  useEffect(() => {
    const trackPointer = (e) => {
      const pos = e.touches ? e.touches[0] : e;
      if (pos) lastPointerPos.current = { x: pos.clientX, y: pos.clientY };
    };
    window.addEventListener("mousemove", trackPointer);
    window.addEventListener("touchmove", trackPointer, { passive: true });
    return () => {
      window.removeEventListener("mousemove", trackPointer);
      window.removeEventListener("touchmove", trackPointer);
    };
  }, []);

  // useEffect(() => {
  //   const container = document.getElementById("scroll-container");
  //   if (!container) return;

  //   const scrollThreshold = 50; // Margen en px para activar el scroll

  //   const handleMove = (clientX) => {
  //     const { left, width } = container.getBoundingClientRect();

  //     if (clientX - left < scrollThreshold) {
  //       startScrolling("left");
  //     } else if (clientX > left + width - scrollThreshold) {
  //       startScrolling("right");
  //     } else {
  //       stopScrolling();
  //     }
  //   };

  //   const handleMouseMove = (e) => {
  //     handleMove(e.clientX);
  //   };

  //   const handleTouchMove = (e) => {
  //     if (e.touches.length > 0) {
  //       handleMove(e.touches[0].clientX);
  //     }
  //   };

  //   const startScrolling = (direction) => {
  //     if (scrollDirection === direction) return; // Evita reiniciar si ya está en la misma dirección

  //     stopScrolling(); // Detiene cualquier otro intervalo activo antes de iniciar uno nuevo
  //     setScrollDirection(direction);

  //     const interval = setInterval(() => {
  //       if (direction === "left") {
  //         container.scrollLeft -= 5;
  //       } else if (direction === "right") {
  //         container.scrollLeft += 5;
  //       }
  //     }, 10);

  //     setScrollInterval(interval);
  //   };

  //   const stopScrolling = () => {
  //     if (scrollInterval) {
  //       clearInterval(scrollInterval);
  //       setScrollInterval(null);
  //     }
  //     setScrollDirection(null);
  //   };

  //   container.addEventListener("mousemove", handleMouseMove);
  //   container.addEventListener("mouseleave", stopScrolling);
  //   container.addEventListener("touchmove", handleTouchMove);
  //   container.addEventListener("touchend", stopScrolling);

  //   return () => {
  //     container.removeEventListener("mousemove", handleMouseMove);
  //     container.removeEventListener("mouseleave", stopScrolling);
  //     container.removeEventListener("touchmove", handleTouchMove);
  //     container.removeEventListener("touchend", stopScrolling);
  //     stopScrolling();
  //   };
  // }, [scrollDirection, scrollInterval]);

  const startColumnAutoScroll = () => {
    isDraggingRef.current = true;
    const loop = () => {
      if (!isDraggingRef.current) return;
      const { x, y } = lastPointerPos.current;

      // Auto-scroll horizontal del contenedor de columnas (muelles)
      const scrollContainer = containerRef.current;
      if (scrollContainer) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const horizontalThreshold = 80;
        if (x < containerRect.left + horizontalThreshold) {
          scrollContainer.scrollLeft -= 12;
        } else if (x > containerRect.right - horizontalThreshold) {
          scrollContainer.scrollLeft += 12;
        }
      }

      // Buscar directamente en el DOM el droppable bajo el cursor X que tenga scroll vertical
      const droppables = document.querySelectorAll('[data-rbd-droppable-id]');
      for (const droppable of droppables) {
        const rect = droppable.getBoundingClientRect();
        if (x < rect.left || x > rect.right) continue;
        if (droppable.scrollHeight <= droppable.clientHeight) continue;
        const threshold = 80;
        if (y < rect.top + threshold) {
          droppable.scrollTop -= 8;
        } else if (y > rect.bottom - threshold) {
          droppable.scrollTop += 8;
        }
        break;
      }

      dragScrollRaf.current = requestAnimationFrame(loop);
    };
    dragScrollRaf.current = requestAnimationFrame(loop);
  };

  const stopColumnAutoScroll = () => {
    isDraggingRef.current = false;
    if (dragScrollRaf.current) {
      cancelAnimationFrame(dragScrollRaf.current);
      dragScrollRaf.current = null;
    }
  };

  const onDragStart = () => {
    startColumnAutoScroll();
  };

  const onDragUpdate = (result) => {
    const { draggableId } = result;

    // Obtener las coordenadas del Draggable
    const draggableElement = document.querySelector(
      `[data-rbd-draggable-id='${draggableId}']`
    );
    if (!draggableElement) return;

    const draggableRect = draggableElement.getBoundingClientRect();

    // Auto-scroll vertical dentro de la columna bajo el puntero
    const verticalContainer = getVerticalScrollContainerAtPoint(
      lastPointerPos.current.x
    );
    if (verticalContainer) {
      const verticalRect = verticalContainer.getBoundingClientRect();
      const verticalThreshold = 60;

      if (draggableRect.top < verticalRect.top + verticalThreshold) {
        startVerticalScrolling(verticalContainer, "up");
      } else if (
        draggableRect.bottom >
        verticalRect.bottom - verticalThreshold
      ) {
        startVerticalScrolling(verticalContainer, "down");
      } else {
        stopVerticalScrolling();
      }
    } else {
      stopVerticalScrolling();
    }
  };

  // Obtener el contenedor scrollable vertical (la columna) bajo el puntero
  const getVerticalScrollContainerAtPoint = (x) => {
    const droppableId = getDroppableIdAtPoint(x);
    if (!droppableId) return null;
    return document.querySelector(
      `[data-rbd-droppable-id='${droppableId}']`
    );
  };

  // Iniciar el scroll vertical automático de una columna
  const startVerticalScrolling = (element, direction) => {
    if (
      verticalScroll.current.interval &&
      verticalScroll.current.direction === direction &&
      verticalScroll.current.element === element
    ) {
      return; // Ya está corriendo en la misma dirección y columna
    }

    stopVerticalScrolling();

    verticalScroll.current = {
      direction,
      element,
      interval: setInterval(() => {
        if (!element) return;
        element.scrollTop += direction === "up" ? -10 : 10;
      }, 10),
    };
  };

  // Detener el scroll vertical automático
  const stopVerticalScrolling = () => {
    if (verticalScroll.current.interval) {
      clearInterval(verticalScroll.current.interval);
    }
    verticalScroll.current = { interval: null, direction: null, element: null };
  };

  // Función para iniciar el scroll automático
  const startScrolling = (direction) => {
    if (scrollInterval) return; // Evitar múltiples intervalos

    const interval = setInterval(() => {
      const container = containerRef.current;
      if (!container) return;

      if (direction === "left") {
        container.scrollLeft -= 10; // Ajusta la velocidad del scroll
      } else if (direction === "right") {
        container.scrollLeft += 10; // Ajusta la velocidad del scroll
      }
    }, 10); // Intervalo de tiempo para el scroll

    setScrollInterval(interval);
  };

  // Función para detener el scroll automático
  const stopScrolling = () => {
    if (scrollInterval) {
      clearInterval(scrollInterval);
      setScrollInterval(null);
    }
  };

  const getContainerPositionHandler = async () => {
    await getContainerPosition();
  };

  const getDroppableIdAtPoint = (x) => {
    for (const container of containers) {
      const el = document.getElementById(container._id);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (x >= rect.left && x <= rect.right) {
          return container._id;
        }
      }
    }
    return null;
  };

  const updateContainers = async (codigo_posicion, updatedList) => {
    const newContainerPositions = (updatedList || containers).map((container) => {
      return {
        codigo_muelle: container.codigo_muelle,
        nombre_muelle: container.nombre_muelle,
        contenedores: container.cards.map(
          ({ position, codigo_muelle, extendedProps }) => ({
            ...extendedProps,
            orden: position,
            codigo_muelle,
          })
        ),
      };
    });

    console.log("newContainerPositions", newContainerPositions);

    // if (tipo === "salida") {
    //   return updateOutputContainerPositions(newContainerPositions);
    // }

    await updateContainerPosition(
      newContainerPositions,
      codigo_posicion,
      log_usu_id
    );
  };

  const addMoreCard = (title, index) => {
    const date = new Date();

    const newCard = {
      date: `${date.getDate()} ${date.toLocaleString("default", {
        month: "short",
      })}, ${date.getFullYear()}`,
      content: "Add your content here..",
      title: title,
    };

    const reqList = containers[index];
    reqList.cards = [...reqList.cards, newCard];

    const modList = {
      ...reqList,
      cards: reqList.cards,
    };

    const allLists = [...containers];
    allLists[index] = modList;
    //axios.put(`/upload/card/${user._id}`, { lists: allLists })
  };

  const updateCardContent = (content, listIndex, cardIndex) => {
    containers[listIndex].cards[cardIndex].content = content;
    let allLists = [...containers];

    //axios.put(`/upload/card/${user._id}`, { lists: allLists })
  };

  const finalizarCard = async (listIndex, cardIndex) => {
    const allListsCopy = [...containers];
    const allCardsCopy = [...allListsCopy[listIndex].cards];
    //await archivarCard(allCardsCopy[cardIndex].id)
    allCardsCopy.splice(cardIndex, 1);
    allListsCopy[listIndex].cards = allCardsCopy;
    console.log("allListsCopy", allListsCopy);
    setContainers(allListsCopy);
  };

  const updateListTitle = (title, index) => {
    const list = containers[index];
    list.title = title;
    const allLists = [...containers];
    //axios.put(`/upload/list/${user._id}`, { lists: allLists })
  };

  const onDragEndss = async (result) => {
    const { destination, source, draggableId, type } = result;

    if (!destination) {
      return;
    }

    const sourceListIndex = containers.findIndex(
      (list) => list._id === source.droppableId
    );
    const draggingCard = containers[sourceListIndex].cards[source.index];

    const updatedList = [...containers];
    updatedList[sourceListIndex].cards.splice(source.index, 1);
    updatedList[sourceListIndex].cards.splice(
      destination.index,
      0,
      draggingCard
    );

    // Actualizar las posiciones de las tarjetas
    for (let i = 0; i < updatedList[sourceListIndex].cards.length; i++) {
      updatedList[sourceListIndex].cards[i].position = i;
    }

    //await cambiarPosicionCard(updatedList[sourceListIndex].cards);
  };

  const onDragEnd = async (result) => {
    stopColumnAutoScroll();
    stopScrolling();
    stopVerticalScrolling();

    const { destination, source, draggableId, type } = result;

    if (!source) {
      return;
    }

    // Usar la posición real del puntero para detectar la columna destino correcta
    // (fix para cuando react-beautiful-dnd reporta destino desactualizado o nulo tras auto-scroll)
    const { x } = lastPointerPos.current;
    const actualDroppableId = getDroppableIdAtPoint(x);
    const effectiveDroppableId =
      actualDroppableId || (destination && destination.droppableId);

    if (!effectiveDroppableId) {
      return;
    }

    const sourceListIndex = containers.findIndex(
      (list) => list._id === source.droppableId
    );
    const destinationListIndex = containers.findIndex(
      (list) => list._id === effectiveDroppableId
    );

    if (sourceListIndex === -1 || destinationListIndex === -1) {
      return;
    }

    const draggingCard = containers[sourceListIndex].cards[source.index];

    // Si rbd no reportó destino (por auto-scroll), soltar al final de la columna
    const destinationIndex = destination
      ? destination.index
      : containers[destinationListIndex].cards.length;

    if (source.droppableId === effectiveDroppableId) {
      // Mover dentro de la misma columna
      const updatedList = [...containers];
      updatedList[sourceListIndex].cards.splice(source.index, 1);
      updatedList[sourceListIndex].cards.splice(
        destinationIndex,
        0,
        draggingCard
      );

      // Actualizar las posiciones de las tarjetas en la misma columna
      for (let i = 0; i < updatedList[sourceListIndex].cards.length; i++) {
        updatedList[sourceListIndex].cards[i].position = i;
      }

      setContainers(updatedList);
      await updateContainers(draggingCard.extendedProps.codigo_posicion, updatedList);
      await getContainerPositionHandler();
      //await cambiarPosicionCard(updatedList[sourceListIndex].cards,updatedList[sourceListIndex].title);
    } else {
      // Mover a otra columna
      const updatedSourceList = [...containers];
      updatedSourceList[sourceListIndex].cards.splice(source.index, 1);

      const updatedDestinationList = [...containers];
      updatedDestinationList[destinationListIndex].cards.splice(
        destinationIndex,
        0,
        draggingCard
      );

      // Actualizar las posiciones de las tarjetas en la columna de origen
      for (
        let i = 0;
        i < updatedSourceList[sourceListIndex].cards.length;
        i++
      ) {
        updatedSourceList[sourceListIndex].cards[i].position = i;
      }

      // Actualizar las posiciones de las tarjetas en la columna de destino
      for (
        let i = 0;
        i < updatedDestinationList[destinationListIndex].cards.length;
        i++
      ) {
        updatedDestinationList[destinationListIndex].cards[i].position = i;
        updatedDestinationList[destinationListIndex].cards[i].codigo_muelle =
          updatedDestinationList[destinationListIndex].codigo_muelle;
      }

      setContainers(updatedDestinationList);
      await updateContainers(draggingCard.extendedProps.codigo_posicion, updatedDestinationList);
      await getContainerPositionHandler();

      /*await Promise.all([
            cambiarPosicionCard(updatedSourceList[sourceListIndex].cards,updatedSourceList[sourceListIndex].title),
            cambiarPosicionCard(updatedDestinationList[destinationListIndex].cards,updatedDestinationList[destinationListIndex].title),
          ]);*/
    }
  };

  const onDragEndD = (result) => {
    const { destination, source, draggableId, type } = result;

    if (!destination) {
      return;
    }

    if (type === "list") {
      const tempList = containers[source.index];
      containers[source.index] = containers[destination.index];
      containers[destination.index] = tempList;
      const allLists = [...containers];
      //axios.put(`/upload/card/${user._id}`, { lists: allLists });
      console.log("regreso 2");
      return;
    }

    //console.log("type",type,lists)

    const destinationListIndex = containers.findIndex(
      (list) => list._id === destination.droppableId
    );
    const sourceListIndex = containers.findIndex(
      (list) => list._id === source.droppableId
    );
    const draggingCard = containers[sourceListIndex].cards[source.index];

    if (source.droppableId === destination.droppableId) {
      const updatedList = [...containers];
      console.log("====== 1", updatedList);

      updatedList[sourceListIndex].cards.splice(source.index, 1);
      updatedList[destinationListIndex].cards.splice(
        destination.index,
        0,
        draggingCard
      );
      console.log("====== 2", updatedList);

      //axios.put(`/upload/card/${user._id}`, { lists: updatedList });
    } else {
      console.log("type", "entro 2");

      const updatedSourceList = [...containers[sourceListIndex].cards];
      const updatedDestinationList = [
        ...containers[destinationListIndex].cards,
      ];
      updatedSourceList.splice(source.index, 1);
      updatedDestinationList.splice(destination.index, 0, draggingCard);

      const allLists = [...containers];
      allLists[sourceListIndex].cards = updatedSourceList;
      allLists[destinationListIndex].cards = updatedDestinationList;
      //axios.put(`/upload/card/${user._id}`, { lists: allLists });
    }
  };

  return (
    <StoredApi.Provider
      value={{ addMoreCard, updateListTitle, updateCardContent, finalizarCard }}
    >
      <DragDropContext onDragEnd={onDragEnd} onDragUpdate={onDragUpdate} onDragStart={onDragStart}>
        <Droppable droppableId="list" type="list" direction="horizontal">
          {(provided) => (
            <div
              id="scroll-container"
              className={classes.root}
              ref={(el) => {
                provided.innerRef(el);
                containerRef.current = el;
              }}
              {...provided.droppableProps}
            >
              {containers &&
                containers.map((list, index) => {
                  return (
                    <List
                      checkBooks={checkBooks}
                      forkliftDrivers={forkliftDrivers}
                      getContainerPosition={getContainerPosition}
                      list={list}
                      key={list._id}
                      index={index}
                    />
                  );
                })}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </StoredApi.Provider>
  );
};

export default Home;
